<template>
    <main id="js-page-content" class="err-v2" role="main">
        <portal to="ariane">
            <div class="tbv2-page-title">{{ $t('forbidden.title') }}</div>
        </portal>

        <div class="err-container">
            <div class="err-icon err-icon--danger">
                <i class="fal fa-lock"></i>
            </div>
            <div class="err-code">403</div>
            <h1 class="err-title">{{ $t('forbidden.title') }}</h1>
            <p class="err-text">{{ $t('forbidden.message') }}</p>
            <router-link to="/" class="err-btn">
                <i class="fal fa-arrow-left"></i>
                {{ $t('forbidden.link') }}
            </router-link>
        </div>
    </main>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
export default {
    name: 'Forbidden'
}
</script>

<style scoped>
.err-v2 {
    width: 100%;
    min-height: 70vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 24px;
    font-family: var(--v2-font-sans);
    color: var(--v2-text-2);
}

.tbv2-page-title {
    font-size: 0.95rem;
    font-weight: var(--v2-font-weight-semibold);
    color: var(--v2-text-1);
    letter-spacing: -0.005em;
}

.err-container {
    text-align: center;
    max-width: 460px;
    width: 100%;
}

.err-icon {
    width: 72px;
    height: 72px;
    border-radius: var(--v2-radius-lg);
    background: var(--v2-primary-soft);
    color: var(--v2-primary);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.75rem;
    margin: 0 auto 18px;
}

.err-icon--danger {
    background: rgba(239, 68, 68, 0.1);
    color: var(--v2-danger);
}

.err-code {
    font-size: 5.5rem;
    font-weight: var(--v2-font-weight-bold);
    color: var(--v2-text-1);
    letter-spacing: -0.04em;
    line-height: 0.95;
    margin-bottom: 14px;
    font-variant-numeric: tabular-nums;
}

.err-title {
    font-size: 1.25rem;
    font-weight: var(--v2-font-weight-semibold);
    color: var(--v2-text-1);
    margin: 0 0 8px;
    letter-spacing: -0.015em;
}

.err-text {
    font-size: var(--v2-text-sm-size);
    color: var(--v2-text-3);
    margin: 0 0 28px;
    line-height: 1.5;
}

.err-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    height: 40px;
    padding: 0 20px;
    border-radius: var(--v2-radius-md);
    background: var(--v2-primary);
    color: #fff !important;
    font-size: var(--v2-text-sm-size);
    font-weight: var(--v2-font-weight-semibold);
    text-decoration: none !important;
    transition: background var(--v2-transition-fast), box-shadow var(--v2-transition-fast);
}

.err-btn i {
    color: #fff !important;
    font-size: 0.8rem;
}

.err-btn:hover {
    background: var(--v2-primary-hover, #0e7490);
    box-shadow: var(--v2-shadow-sm);
}

@media (max-width: 640px) {
    .err-code {
        font-size: 4rem;
    }

    .err-icon {
        width: 60px;
        height: 60px;
        font-size: 1.4rem;
    }
}
</style>
